<template>
  <div class="spacer">
    <div class="fixed-bottom bg-danger text-white p-2 announcement">
      <div class="row no-gutters align-items-center announcement-container">
        <div class="col text-center">
          <i class="fa fa-bullhorn fa-2x my-1" aria-hidden="true" />
        </div>
        <div v-if = 'userLang.toString().includes("fr")' class="col-12 col-md-11">
          {{message || 'Bienvenue sur la nouvelle version de Keep N Eye. Pour en savoir plus sur les changements, visitez ce lien: '}} <a target="_blank" style="color:black;" href="https://help.keepneye.com/changelog-transport-fr.html">https://help.keepneye.com/changelog-transport-fr.html</a>
        </div>
        <div v-else class="col-12 col-md-11">
          {{message || 'Welcome to the new version of Keep N Eye. To know more about the new changes, visit this link: '}} <a target="_blank" style="color:black;" href="https://help.keepneye.com/changelog-transport-en.html">https://help.keepneye.com/changelog-transport-en.html</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'generalAnnouncement',
  props: {
    message: {
      type: String,
      required: false
    }
  },
  computed: {
    userLang () {
      return navigator.language
    }
  }
}
</script>

<style scoped>
  .spacer {
    margin-top: 6rem;
  }
  .announcement {
    min-height: 75px;
  }
  .announcement-container {
    min-height: 60px;
  }
</style>
